// Registro do Service Worker para PWA offline e suporte às lojas
// Só ativa em produção (build)

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  window.location.hostname === '[::1]' ||
  window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4]\d|[01]?\d\d?)){3}$/)
)

export function register(config) {
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href)
    if (publicUrl.origin !== window.location.origin) return

    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`
      if (isLocalhost) {
        checkValidServiceWorker(swUrl, config)
        navigator.serviceWorker.ready.then(() => {
          console.log('[CifrasBand] SW ativo em localhost.')
        })
      } else {
        registerValidSW(swUrl, config)
      }
    })
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker.register(swUrl).then((registration) => {
    registration.onupdatefound = () => {
      const installingWorker = registration.installing
      if (!installingWorker) return
      installingWorker.onstatechange = () => {
        if (installingWorker.state === 'installed') {
          if (navigator.serviceWorker.controller) {
            // Nova versão disponível — notifica o app
            console.log('[CifrasBand] Nova versão disponível.')
            if (config && config.onUpdate) config.onUpdate(registration)
          } else {
            console.log('[CifrasBand] Conteúdo salvo para uso offline.')
            if (config && config.onSuccess) config.onSuccess(registration)
          }
        }
      }
    }
  }).catch((error) => {
    console.error('[CifrasBand] Erro ao registrar SW:', error)
  })
}

function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl, { headers: { 'Service-Worker': 'script' } })
    .then((response) => {
      const contentType = response.headers.get('content-type')
      if (response.status === 404 || (contentType && !contentType.includes('javascript'))) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => window.location.reload())
        })
      } else {
        registerValidSW(swUrl, config)
      }
    })
    .catch(() => console.log('[CifrasBand] Sem internet — rodando offline.'))
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => registration.unregister())
      .catch((error) => console.error(error.message))
  }
}
